module.exports = "/_next/static/images/loading_16-7c3923ab62b40d674bf4a4e3115bdf10.png";